var map = {
	"./brain-logo.svg": 381,
	"./extensive.svg": 382,
	"./icons/001-category-1.svg": 182,
	"./icons/001-category.svg": 383,
	"./icons/002-medicine.svg": 384,
	"./icons/external.svg": 385,
	"./icons/menu-default-icon.svg": 386,
	"./icons/notes.svg": 387,
	"./loading.svg": 388,
	"./logo-beta.svg": 389,
	"./logo-white.svg": 181,
	"./logo.svg": 89,
	"./practical.svg": 390,
	"./quick.svg": 391,
	"./referenced.svg": 392
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 730;